<!--  -->
<template>
  <div>
    <zlr-modal v-model="fileModal">
      <div class="own-file">
        <!-- <h1>上传头像</h1> -->
        <p>只能上传3MB大小以下的文件</p>
        <upload :size=3
                path="head"
                on-error="uploadError"
                v-model="upload"></upload>
        <div class="btn-con">
          <Button class="zlr-btn-default"
                  @click="fileModal= false">关闭</Button>
          <Button class="zlr-btn-primary"
                  @click="handleSub"
                  :disabled="!upload"
                  type="primary"
                  :loading="isSub">上传</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// api
import { saveModifyCV, saveModifyReportCard } from '@/api/info'
// componnets
import ZlrModal from '_c/modal/modal'
import Upload from '_c/upload/upload'
export default {
  name: '',
  props: ['menteeNum', 'type'],
  components: {
    ZlrModal,
    Upload
  },
  data () {
    return {
      fileModal: false,
      upload: '',
      isSub: false,
      cvPath: `mentee/${this.menteeNum}/personal/cv/${Date.now()}`,
      reportCardPath: `mentee/${this.menteeNum}/personal/cv/${Date.now()}`
    }
  },
  computed: {},
  mounted () { },
  methods: {
    handleShow () {
      this.fileModal = true
    },
    // 确认上传
    handleSub () {
      this.isSub = true
      this.suData(this.upload).then(() => {
        this.$zlr_message('上传成功', 'success')
        this.$emit('on-upload-success')
        this.fileModal = false
        this.isSub = false
      }).catch(error => {
        this.$zlr_message(error.message, 'error')
      })
    },
    // 上传错误
    uploadError () {
    },
    suData (url) {
      return new Promise((resolve, reject) => {
        if (this.type === 'CV') {
          saveModifyCV({
            cvUrl: url
          }).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }
        if (this.type === 'reportCard') {
          saveModifyReportCard({
            reportCardUrl: url
          }).then(res => {
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }
      })
    }
  },
  watch: {
    fileModal () {
      this.upload = ''
    }
  }
}
</script>
<style lang='less' scoped>
</style>
